import { useContext } from "react";
import { ContextRegisterProduct } from "../context";
import Modal from "react-modal/lib/components/Modal";
import { IndexHooks } from "./hook";
import Switch from "@mui/material/Switch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare, faSquare } from "@fortawesome/free-regular-svg-icons";
import closeImg from "../../../../assets/close.png";
import "./style.css";
import { BtnSearch } from "../../../../components/button/button-search";
import Loading from "../../../../components/loading";
import LoadingFull from "../../../../components/loading/loading-full";

const FilterRegisterProduct = () => {
	const { isOpenModalFilter, handleCloseModalFilter } = useContext(ContextRegisterProduct);

	const {
		errors,
		isSubmitting,
		register,
		handleSubmit,
		handleOnSubmit,
		paramSelected,
		tipoprodutoSelected,
		setFocus,
		Controller,
		control,
	} = IndexHooks();

	const parameters = [
		{ id: 1, label: "Descrição", value: "nome" },
		{ id: 2, label: "Ean", value: "ean" },
		{ id: 3, label: "Referência", value: "referencia" },
		{ id: 4, label: "Categoria", value: "categoria" },
	];

	const tiposProduto = [
		{ id: "tipo-pai", label: "Somente Pai", value: "pai" },
		{ id: "tipo-filho", label: "Somente Filhos", value: "filho" },
		{ id: "tipo-todos", label: "Todos", value: "todos" },
	];

	const handleRadioOnClick = (e) => {
		setFocus("paramValue");
	};

	return (
		<Modal
			isOpen={isOpenModalFilter}
			onRequestClose={handleCloseModalFilter}
			overlayClassName="react-modal-overlay"
			className="react-modal-content"
		>
			<div className="container-filter-client">
				{isSubmitting && <LoadingFull mensagem=" Pesquisando aguarde..." />}

				<form action="" onSubmit={handleSubmit(handleOnSubmit)}>
					<header>
						<h2 className="title">Produtos</h2>
						<h6 className="text-xs border-botton mt-3 text-secondary">Pesquisar por...</h6>
						<button
							type="button"
							className="react-modal-close"
							onClick={(e) => handleCloseModalFilter()}
						>
							<img src={closeImg} alt="" />
						</button>
					</header>
					<div className="field-group">
						<div className="row">
							<div className="container-radio d-flex align-items-center flex-wrap col-10">
								{parameters.map((option) => (
									<div key={option.id} className="radio col-6 col-sm-4 col-lg-4">
										<input
											type="radio"
											id={option.id}
											value={JSON.stringify(option)}
											onClick={(event) => handleRadioOnClick()}
											{...register("param")}
											style={{ display: "none" }}
										/>
										<label htmlFor={option.id}>
											<span htmlFor={option.id} style={{ marginRight: "0.5rem" }}>
												<FontAwesomeIcon
													icon={
														JSON.parse(paramSelected).value === option.value
															? faCheckSquare
															: faSquare
													}
													className="custom-checkbox"
												/>
											</span>
											{option.label}
										</label>
									</div>
								))}
							</div>
							{errors.param && <p className="errors">{errors.param.message}</p>}

							<div className="container-switch col-2 flex-wrap">
								<div className="check-input d-flex align-items-center justify-content-end">
									<Controller
										name="active"
										control={control}
										defaultValue={true}
										render={({ field }) => (
											<Switch
												checked={field.value}
												onChange={(e) => field.onChange(e.target.checked)}
												inputProps={{
													"aria-label": "Clientes Ativos",
												}}
											/>
										)}
									/>
									<label htmlFor="active">Ativo</label>
									{errors.active && <p className="errors">{errors.active.message}</p>}
								</div>
							</div>
						</div>

						<div className="mt-3">
							<h6 className="text-xs border-botton text-secondary mb-2">Tipo de produto</h6>
							<div className="container-radio d-flex align-items-center flex-wrap">
								{tiposProduto.map((opt) => (
									<div key={opt.id} className="radio col-4">
										<input
											type="radio"
											id={opt.id}
											value={opt.value}
											{...register("tipoproduto")}
											style={{ display: "none" }}
										/>
										<label htmlFor={opt.id}>
											<span style={{ marginRight: "0.5rem" }}>
												<FontAwesomeIcon
													icon={tipoprodutoSelected === opt.value ? faCheckSquare : faSquare}
													className="custom-checkbox"
												/>
											</span>
											{opt.label}
										</label>
									</div>
								))}
							</div>
						</div>

						<div className="input-box mt-3">
							<label htmlFor="paramValue">{JSON.parse(paramSelected).label}</label>
							<input
								id="paramValue"
								{...register("paramValue")}
								type="text"
								autoComplete="off"
								onFocus={(e) => e.target.select()}
								autoFocus
							/>
							{errors.paramValue && <p className="errors">{errors.paramValue.message}</p>}
						</div>
					</div>
					<footer>
						<BtnSearch isSubmitting={isSubmitting} />
					</footer>
				</form>
			</div>
		</Modal>
	);
};

export default FilterRegisterProduct;
